import React, {FormEvent, Fragment, Component} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {
    Button,
    TextField
} from '@material-ui/core';
import {userEditFormChange, resetUserEditForm, update} from '../../../vendors/actions/user'
import {toggleUserEdit} from "../../../vendors/actions/layout";
import {UserFormSerializer} from "../../../vendors/utils/serializers";
import InputMask from "react-input-mask";
import {User} from "../../../vendors/redux/reducers/user";
import {Form} from "../../../vendors/redux/reducers/userEditFrom";
import {isMobileBrowser, scrollTo} from "../../../vendors/utils/common";

const MaskedComponent = (props: any) => {
    const {...other} = props;
    return (
        <InputMask
            {...other}
            mask="(999) 999-9999" maskChar=" "/>
    )
};

interface ConnectStateProps {
    UserEditForm: Form,
    User: User,
}

interface ConnectDispatchProps {
    userEditFormChange: (data: {value: any, field: string, validate: boolean}) => void;
    resetUserEditForm: () => void;
    toggleUserEdit: (data: User | boolean) => void;
    update: (data: User) => void;
}

type HeaderProps = ConnectStateProps & ConnectDispatchProps;

class EditInfo extends Component<HeaderProps> {

    submit = (): void | boolean => {
        if(!this.props.UserEditForm.valid) return false;
        const data = UserFormSerializer(this.props.UserEditForm.data, 'password');
        this.props.update(data);
        isMobileBrowser() && scrollTo({top: 0, behavior: 'smooth'})
    };

    changeForm = (e: any, field: string, validate: boolean = false): void => {
        let value = e.target.value;
        if (field === 'phone' && value) {
            value = value.replace(/\D+/g, '');
            if (value) {
                value = parseInt(value);
            }
        }
        return this.props.userEditFormChange({value, field, validate});
    };

    cancel = (): void => {
        this.props.resetUserEditForm();
        this.props.toggleUserEdit(false)
    };

    render() {
        const form = this.props.UserEditForm.data;
        return (
            <Fragment>
                <TextField
                    fullWidth
                    onBlur={(e: FormEvent) => this.changeForm(e, 'fullName', true)}
                    onChange={(e: FormEvent) => this.changeForm(e, 'fullName')}
                    id="full-name"
                    error={!!form.firstName.error || !!form.lastName.error && form.fullName.dirty}
                    value={form.fullName.value || ''}
                    helperText={form.fullName.dirty && form.lastName.error || form.firstName.error}
                    label="Full Name"
                />
                <TextField
                    fullWidth
                    className='mt-3 mb-4'
                    onBlur={(e: FormEvent) => this.changeForm(e, 'businessName')}
                    onChange={(e: FormEvent) => this.changeForm(e, 'businessName')}
                    id="business-name"
                    value={form.businessName.value || ''}
                    label={(()=> <span>Company Name <i style={{fontWeight: "lighter",fontFamily: 'Roboto'}}>(optional)</i></span>)()}
                />
                <TextField
                    fullWidth
                    id="email"
                    className='mb-2'
                    onBlur={(e: FormEvent) => this.changeForm(e, 'email', true)}
                    onChange={(e: FormEvent) => this.changeForm(e, 'email')}
                    error={!!form.email.error && form.email.dirty}
                    value={form.email.value || ''}
                    helperText={form.email.dirty && form.email.error}
                    label="Email"
                />
                <TextField
                    fullWidth
                    className="mt-2"
                    id="phone"
                    onBlur={(e: FormEvent) => this.changeForm(e, 'phone', true)}
                    onChange={(e: FormEvent) => this.changeForm(e, 'phone')}
                    error={!!form.phone.error && form.phone.dirty}
                    value={form.phone.value || ''}
                    helperText={form.phone.dirty && form.phone.error}
                    InputProps={{
                        inputComponent: MaskedComponent,
                    }}
                    label="Phone Number"
                />
                <div className='my-4 my-sm-0 mt-sm-4 text-center text-sm-left'>
                    <Button
                        onClick={this.submit}
                        size="small"
                        color="default"
                        variant="contained"
                        className="text-purple btn btn-edit">
                        Save Changes
                    </Button>
                    <Button
                        onMouseDown={this.cancel}
                        size="small"
                        color="default"
                        variant="contained"
                        className="text-purple ml-4 btn btn-cancel">
                        Never Mind
                    </Button>
                </div>
            </Fragment>
        );
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, Object>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, UserEditForm} = state;
    return {
        User,
        UserEditForm
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, Object>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        userEditFormChange: (data: {}) => dispatch(userEditFormChange(data)),
        resetUserEditForm: () => dispatch(resetUserEditForm()),
        toggleUserEdit: (data: User | boolean) => dispatch(toggleUserEdit(data)),
        update: (data: User) => dispatch(update(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EditInfo);


